import { useState, useEffect, Fragment } from "react"
import { toast } from "react-toastify";
import { useQuery, useInfiniteQuery } from '@tanstack/react-query';

import CLink from "../components/CLink";
import axios from "../scripts/axiosConfig";
import ProblemsList from "../components/ProblemsList";

import { BiError } from "react-icons/bi"

import challengeImage from "../assets/coding.png?w=100&h=100&format=webp"

import "../styles/Explore.scss";


export default function Explore() {
    
    const { isLoading: isChallengesLoading, error: challengesError, data: challenges, isSuccess: isChallengesSuccess, isError: isChallengesError  } = useQuery({
        queryKey: ['allChallenges'],
        queryFn: async () => {
            const res = await axios.get("/challenges/get-all", {}, { timeout: 5000, timeoutErrorMessage: "SERVER TIMEOUT" });
            return res.data.data;
        },
        failureCount: 2,
        refetchOnWindowFocus: false
    });

    const [problemsPerPage, setProblemsPerPage] = useState(5);
    const [lastSeenId, setLastSeenId] = useState(null);

    const fetchProblems = async ({ pageParam = 0 }) => {
        const res = await axios.post(
            "/problem/get-all", 
            { 
                page: pageParam, 
                perPage: problemsPerPage, 
                lastSeenId: lastSeenId, 
                fields: ["id", "title", "difficulty", "tags"] 
            }, 
            { timeout: 5000, timeoutErrorMessage: "SERVER TIMEOUT" }
        );
        
        const problems = res.data;
        if (problems.length === 0) {
            return { data: [], nextPage: null, hasMore: false };
        }
        setLastSeenId(problems[problems.length - 1]._id);
        return { data: problems, nextPage: pageParam + 1, hasMore: problems.length === problemsPerPage };
    };

    const {
        data: problemsData,
        isLoading: isProblemsLoading,
        error: problemsError,
        isSuccess: isProblemsSuccess,
        isError: isProblemsError,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage
    } = useInfiniteQuery({
        queryKey: ['projects'],
        queryFn: fetchProblems,
        getNextPageParam: (lastPage) => (lastPage.hasMore ? lastPage.nextPage : undefined),
        refetchOnWindowFocus: false,
        failureCount: 2
    });


    useEffect(() => {
        if (isChallengesError) {
            if (challengesError.message === "SERVER TIMEOUT") {
                toast.error("Server is experiencing unexpected downtime. Please try again later.", { autoClose: 5000 }  );
            }
            else {
                toast.error(challengesError.message, { autoClose: 5000 } );
            }
        }
    }, [challengesError]);
    

    return (
        <div className="explore">

            <div className="challengesGrid">
                {
                    (isChallengesSuccess && Object.keys(challenges).length > 0 ) && (
                        Object.keys(challenges).map((challengeID, index) => {
                            return (
                                <Fragment key={index}>
                                    <CLink to={`/challenges/${challenges[challengeID].url}`} className="challenge">
                                        <div className="challengeInfo"> 
                                            <img src={challengeImage} alt="" />
                                            <div className="text">
                                                <span className="name">{challenges[challengeID].name}</span>
                                                <span className="about">{challenges[challengeID].description}</span>
                                            </div>
                                        </div>
                                        
                                    </CLink>
                                </Fragment>
                            )
                        })
                    )
                }
                {
                    (isChallengesError) && (
                        <span className="errorMessage">
                            <BiError size={"80px"} />
                            <span>
                                Looks like there's a problem with the server. Please try again later.
                            </span>
                        </span>
                    )
                }
                {
                    (isChallengesLoading) && (
                        [1,2,3].map((card, index) => {
                            return (
                                <div className="challenge" key={index}>
                                    <div className="challengeInfo">
                                        <div className="image loading"/>
                                        <div className="text">
                                            <span className="name loading">lorem ipsum</span>
                                            <span className="about loading">Lorem ipsum, dolor sit amet consectetur </span>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    )
                }
            </div>

            <div className="problemsList">
                <div className="problemsContent">

                    <div className="problems">

                        <h2 className="header">Problems</h2>

                        {
                            (isProblemsSuccess && problemsData.pages.length > 0) && (
                                <ProblemsList
                                    problems={problemsData.pages.flatMap(page => page.data)}
                                    refresh={fetchNextPage}
                                />
                            )
                        }
                        {
                            (
                                (isProblemsLoading) && (
                                    [1, 2, 3, 4, 5].map((card, index) => (
                                        <div className="problem loading" key={index}>
                                            <div className="status loading"></div>
                                            <div className="name loading"></div>
                                            <div className="difficulty loading"></div>
                                        </div>
                                    ))
                                )
                            )
                        }
                        {
                            (isProblemsError) && (
                                <span className="errorMessage">
                                    <BiError size={"80px"} />
                                    <span>
                                        Looks like there's a problem with the server. Please try again later.
                                    </span>
                                </span>
                            )
                        }
                    </div>

                    <div className="calendar">
                        Calendar
                    </div>

                </div>
            </div>

        </div>

    )
}